import React from 'react';
import { motion } from 'framer-motion';
import ModernHeader from '../../components/modern/ModernHeader';
import ModernFooter from '../../components/modern/ModernFooter';
import SEO from '../../components/modern/SEO';

export default function ModernASZF() {
  return (
    <>
      <SEO 
        title="Általános Szerződési Feltételek - XL bútor"
        description="XL bútor ÁSZF - általános szerződési feltételek, rendelési információk, szállítás, fizetés, jótállás."
      />
      
      <div className="bg-[var(--color-bg)]">
        <ModernHeader />
        
        <main>
          {/* Hero Section */}
          <section className="relative py-20 md:py-28 bg-gradient-to-br from-[var(--color-text-primary)] to-gray-800">
            <div className="mx-auto max-w-[var(--container-max)] px-4 text-center">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <h1 className="text-4xl md:text-5xl font-[var(--font-serif)] font-semibold text-white mb-6 tracking-tight">
                  Általános Szerződési Feltételek
                </h1>
                <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto">
                  Szolgáltatásaink igénybevételének feltételei
                </p>
              </motion.div>
            </div>
          </section>

          {/* Content Section */}
          <section className="py-16 md:py-24 bg-white">
            <div className="mx-auto max-w-[900px] px-4">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="space-y-12"
              >
                {/* 1. Általános rendelkezések */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-6">
                    1. Általános rendelkezések
                  </h2>
                  <div className="bg-[var(--color-bg)] rounded-2xl p-8 shadow-[var(--shadow-subtle)] mb-6">
                    <div className="space-y-3">
                      <p><strong className="text-[var(--color-text-primary)]">Szolgáltató:</strong> <span className="text-[var(--color-text-secondary)]">XL Bútor és Szőnyeg</span></p>
                      <p><strong className="text-[var(--color-text-primary)]">Székhely:</strong> <span className="text-[var(--color-text-secondary)]">4600 Kisvárda, Attila u. 61.</span></p>
                      <p><strong className="text-[var(--color-text-primary)]">E-mail:</strong> <a href="mailto:xlbutorbolt@gmail.com" className="text-[var(--color-accent)] hover:underline">xlbutorbolt@gmail.com</a></p>
                      <p><strong className="text-[var(--color-text-primary)]">Telefon:</strong> <a href="tel:06704179210" className="text-[var(--color-accent)] hover:underline">06 (70) 417 9210</a></p>
                    </div>
                  </div>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">
                    Ezen Általános Szerződési Feltételek (ÁSZF) a XL Bútor és Szőnyeg és ügyfelei közötti 
                    szerződések alapját képezik.
                  </p>
                </div>

                {/* 2. Szerződés létrejötte */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    2. Szerződés létrejötte
                  </h2>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">
                    A szerződés létrejöttét a rendelés megerősítése jelenti. A szolgáltató 48 órán belül 
                    megerősíti a rendelést e-mailben vagy telefonon.
                  </p>
                </div>

                {/* 3. Árak és fizetés */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    3. Árak és fizetés
                  </h2>
                  <ul className="space-y-3 text-[var(--color-text-secondary)]">
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Az árak forintban értendők, ÁFA-val együtt</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Fizetés készpénzzel, bankkártyával vagy átutalással lehetséges</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Előleg fizetés esetén a teljes összeg 50%-a</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Átvételkor a fennmaradó összeg fizetendő</span>
                    </li>
                  </ul>
                </div>

                {/* 4. Szállítás és átvétel */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    4. Szállítás és átvétel
                  </h2>
                  <ul className="space-y-3 text-[var(--color-text-secondary)]">
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Szállítási idő: 2-4 hét a rendeléstől számítva</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Egyedi bútorkészítés esetén: 4-8 hét</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Szállítási költség: 15.000 Ft (Kisvárda és környéke)</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Az átvételkor a termék állapotát ellenőrizni kell</span>
                    </li>
                  </ul>
                </div>

                {/* 5. Jótállás és reklamáció */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    5. Jótállás és reklamáció
                  </h2>
                  <ul className="space-y-3 text-[var(--color-text-secondary)]">
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Jótállási idő: 24 hónap a termék átvételétől</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Reklamációt 8 napon belül kell benyújtani</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Garanciaidő: 2 év a gyártó által</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Hibás termék esetén javítás vagy csere</span>
                    </li>
                  </ul>
                </div>

                {/* 6. Visszavonási jog */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    6. Visszavonási jog
                  </h2>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed mb-4">
                    A fogyasztó 14 napon belül visszavonhatja rendelését a termék átvételétől számítva. 
                    A visszavonás feltételei:
                  </p>
                  <ul className="space-y-3 text-[var(--color-text-secondary)]">
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>A termék eredeti állapotban kell lennie</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Csomagolás és dokumentáció megőrzése szükséges</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>A visszaszállítási költséget a fogyasztó viseli</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-[var(--color-accent)] text-xl flex-shrink-0">•</span>
                      <span>Egyedi bútorkészítés esetén nincs visszavonási jog</span>
                    </li>
                  </ul>
                </div>

                {/* 7. Felelősség */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    7. Felelősség
                  </h2>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">
                    A szolgáltató felelőssége a szerződésben foglalt szolgáltatások teljesítésére korlátozódik. 
                    Közvetett károkért nem vállal felelősséget.
                  </p>
                </div>

                {/* 8. Vitarendezés */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    8. Vitarendezés
                  </h2>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">
                    Szerződéses viták esetén először egyeztetésre törekszünk. 
                    Ha ez nem vezet eredményre, a magyar bíróságok illetékesek.
                  </p>
                </div>

                {/* 9. ÁSZF módosítása */}
                <div>
                  <h2 className="text-2xl md:text-3xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] mb-4">
                    9. ÁSZF módosítása
                  </h2>
                  <p className="text-[var(--color-text-secondary)] leading-relaxed">
                    Jogfenntartjuk magunknak a jogot, hogy ezen ÁSZF-t módosítsuk. 
                    A módosításokról a weboldalunkon keresztül tájékoztatjuk.
                  </p>
                </div>

                {/* Utolsó módosítás */}
                <div className="pt-8 border-t border-gray-200">
                  <p className="text-sm text-[var(--color-text-secondary)]">
                    <strong>Utolsó módosítás:</strong> {new Date().getFullYear()}. {new Date().toLocaleDateString('hu-HU', { month: 'long' })}
                  </p>
                </div>
              </motion.div>
            </div>
          </section>
        </main>
        
        <ModernFooter />
      </div>
    </>
  );
}

